export const apiUrls = {
  notificationsUrl: '/api/notifications',
  applicationSettingsUrl: '/api/ApplicationSettings',
  releaseNotesUrl: '/api/helpFile/releaseNotes',
  userGuideUrl: '/api/helpFile/userGuide',
  navigationUrl: '/api/Navigation',
  exportStatusUrl: '/api/export/status',
  fileDownloadUrl: 'downloadHandler/getFile',
  getDashboardDescriptorUrl: '/api/data-provider/dashboard-descriptor',
  getDataUrl: '/api/data-provider/data',
  getFilterDataUrl: '/api/data-provider/filter-data',
  userPropertiesUrl: '/api/users/properties',
  addPropertyUrl: '/api/users/addproperty',
  advancedMapData: '/api/data-provider/map-data',
  globalFiltersListData: '/api/data-provider/global-filters-list-data',
  createDataProfiles: '/api/data-profiles/create-profiles',
  alarmDefinitionUrl: '/alarm-api/AlarmDefinition',
  alarmRulesCountUrl: '/alarm-api/AlarmRulesCount',
  dataSourceMetadataForAlarmUrl: '/api/data-source-provider/metadata',

  alarmMetadata: '/alarm-api/AlarmsMetaData',
  createAlarmDefinition: '/alarm-api/AlarmDefinition',
  editAlarmDefinition: '/alarm-api/AlarmDefinition',
  deleteAlarmDefinition: '/alarm-api/AlarmDefinition',
  alarmNiDataSourceDataUrl: 'api/data-source-provider/enabled',
  alarmQueryOperatorsUrl: '/alarm-api/AlarmMetaDataOperators',
  alarmDefinitionByIdUrl: '/alarm-api/AlarmDefinitionById',
  duplicateAlarmDefinitionUrl: '/alarm-api/AlarmDefinition/duplicate',
  changeAlarmStatusUrl: '/alarm-api/AlarmDefinition/status',

  geoJSONLayersMetadataUrl: 'api/GeoJSON/getLayersMetadata',
  geoJSONLayerDataUrl: 'api/GeoJSON/getLayerData',
  geoDatProfilesByDataElementIdUrl: 'api/data-profiles/load-profiles',
  getQueryPreviewByDataProfileUrl: 'api/data-profiles/profile-preview',
  getQueryPreviewByQueryRuleUrl: 'api/data-profiles/rule-profile-preview',
  getMapGeoJsonData: 'api/data-provider/map-geojson-data',
  chatbotUrl: 'api/chatbot/stream-chat',
};
